declare const KELLS_SG_AUTH0_DOMAIN: string | undefined;
declare const KELLS_SG_AUTH0_CLIENT_ID: string | undefined;
declare const KELLS_SG_AUTH0_AUDIENCE: string | undefined;

/**
 * Auth0 config for patient-reporting.
 * US builds leave KELLS_SG_AUTH0_* unset → US production tenant (defaults below).
 * SG Netlify CI injects KELLS_SG_AUTH0_* at build time (namespaced to avoid
 * colliding with generic AUTH0_* env vars on the US Netlify site).
 */
export const AuthConfig = {
  domain:
    typeof KELLS_SG_AUTH0_DOMAIN === "string" && KELLS_SG_AUTH0_DOMAIN.trim()
      ? KELLS_SG_AUTH0_DOMAIN.trim()
      : "auth.getkells.com",
  clientId:
    typeof KELLS_SG_AUTH0_CLIENT_ID === "string" &&
    KELLS_SG_AUTH0_CLIENT_ID.trim()
      ? KELLS_SG_AUTH0_CLIENT_ID.trim()
      : "bzald3Y89JfiBmvhbG1tVrqjy4uXXTYQ",
  audience:
    typeof KELLS_SG_AUTH0_AUDIENCE === "string" &&
    KELLS_SG_AUTH0_AUDIENCE.trim()
      ? KELLS_SG_AUTH0_AUDIENCE.trim()
      : "https://kells.auth0.com/api/v2/",
  scope: "openid email profile",
};
